import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initNativeShell } from "@/lib/capacitor";

// No-op on web; wires up StatusBar / SplashScreen / Keyboard / back button /
// deep links when running inside the Capacitor Android or iOS shell.
initNativeShell();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
